export default __webpack_public_path__ + "static/media/black cat looking at viewer.c79a0c6d.webp";